// extracted by mini-css-extract-plugin
export default {"l_drag_and_drop_main":"DragAndDrop_l_drag_and_drop_main__TNCsu","l_drag_and_drop__on_drag_enter":"DragAndDrop_l_drag_and_drop__on_drag_enter__ySL-M"};